import type { ComponentType } from '@grafikr/components';
import Splide from '@splidejs/splide';

const Component: ComponentType = (node) => {
  new Splide(node, {
    arrows: false,
    pagination: false,
    autoWidth: true,
    type: 'loop',
    autoplay: true,
    speed: 1200,
    interval: 2500,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        destroy: true,
      },
    },
  }).mount();
};

export default Component;
